import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getClientToken = () => sessionStorage.getItem('ml_client_token') || '';

const client = axios.create({ baseURL: API });
client.interceptors.request.use((cfg) => {
  const t = getClientToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

/* Thin, typed-ish wrapper around the DaaS client endpoints (all email-isolated server-side). */
export const clientApi = {
  me: () => client.get('/account/me').then((r) => r.data),
  legacyMe: () => client.get('/auth/me').then((r) => r.data),
  createProject: (body) => client.post('/projects', body).then((r) => r.data),
  projectDetail: (id) => client.get(`/projects/${id}/detail`).then((r) => r.data),
  saveRequirements: (id, answers) => client.put(`/projects/${id}/requirements`, { answers }).then((r) => r.data),
  submitRequirements: (id, answers) => client.post(`/projects/${id}/requirements/submit`, { answers }).then((r) => r.data),
  approveScope: (id) => client.post(`/projects/${id}/scope/approve`).then((r) => r.data),
  requestScopeRevision: (id, note) => client.post(`/projects/${id}/scope/revision`, { note }).then((r) => r.data),
  acceptAgreement: (id) => client.post(`/projects/${id}/agreement/accept`).then((r) => r.data),
  requestAddon: (id, body) => client.post(`/projects/${id}/addons/request`, body).then((r) => r.data),
  // ── Phase 4 billing ──
  subscriptionCheckout: (id) => client.post(`/projects/${id}/subscription/checkout`).then((r) => r.data),
  payInvoice: (invoiceId) => client.post(`/invoices/${invoiceId}/pay-online`).then((r) => r.data),
  getMessages: (id) => client.get(`/projects/${id}/messages`).then((r) => r.data),
  postMessage: (id, text) => client.post(`/projects/${id}/messages`, { text }).then((r) => r.data),
  reviewDeliverable: (id, did, status, feedback) =>
    client.post(`/projects/${id}/deliverables/${did}/review`, { status, feedback }).then((r) => r.data),
  registerFile: (id, body) => client.post(`/projects/${id}/files`, body).then((r) => r.data),
  onboardingQuestions: () => axios.get(`${API}/onboarding/questions`).then((r) => r.data),
  uploadFile: (formData) => axios.post(`${API}/upload`, formData).then((r) => r.data),
};

export { API };
